import React from 'react'

function StateTag(props) {
	const state = props.state
	// 统一处理空值/默认
	const normalized = (state === undefined || state === null || state === '') ? '1' : String(state)

	if (normalized === '1') {
		return (
			<span>待提交</span>
		)
	}
	if (normalized === '2') {
		return (
			<span>待审批</span>
		)
	}
	if (normalized === '3') {
		return (
			<span>审批中</span>
		)
	}
	if (normalized === '4') {
		return (
			<span>已驳回</span>
		)
	}
	if (normalized === '5' || normalized === '6') {
		return (
			<span>已结束</span>
		)
	}
	return <span>未知</span>
}

export default StateTag